import { Injectable } from '@angular/core';
import { asyncScheduler, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, observeOn } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private isLoading$$ = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading$$.asObservable().pipe(
    distinctUntilChanged(),
    observeOn(asyncScheduler)
  );

  constructor() { }

  setLoading(isLoading: boolean) {
    this.isLoading$$.next(isLoading);
  }
}
